import { render, staticRenderFns } from "./TomadorCadastro.vue?vue&type=template&id=b2ea944c&scoped=true&"
import script from "./TomadorCadastro.vue?vue&type=script&lang=js&"
export * from "./TomadorCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TomadorCadastro.vue?vue&type=style&index=0&id=b2ea944c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea944c",
  null
  
)

export default component.exports